// ============================================================
// ✅ SCROLL FIX — must run BEFORE React and the browser restores scroll
// ============================================================
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);
document.documentElement.scrollTop = 0;
document.body.scrollTop = 0;

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';
import reportWebVitals from './styles/reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Force top after first render tick, then reveal the app.
requestAnimationFrame(() => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const rootEl = document.getElementById('root');
  if (rootEl) rootEl.classList.add('app-ready');
});

// Safety net — if the RAF fires before layout is complete, retry after 80ms.
setTimeout(() => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const rootEl = document.getElementById('root');
  if (rootEl && !rootEl.classList.contains('app-ready')) {
    rootEl.classList.add('app-ready');
  }
}, 80);

reportWebVitals();